/**
 * PageHeader
 */
import React from 'react';
import clsx from 'clsx';
import { uhmLogo } from 'ui-component-library/assets';
import { Grid, Cell } from 'ui-component-library/base';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var PageHeader = function (_a) {
    var title = _a.title, className = _a.className, logoLink = _a.logoLink, logoSrc = _a.logoSrc, SearchComponent = _a.SearchComponent, SearchComponentMobile = _a.SearchComponentMobile, MenuComponent = _a.MenuComponent, CriteriaCartComponent = _a.CriteriaCartComponent, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, children = _a.children;
    var Link = LinkComponent;
    return (React.createElement("header", { "data-cid": "PageHeader" },
        children,
        React.createElement("div", { className: clsx(className, 'pt-2 md:py-3 border-b-2 border-greyLight') },
            React.createElement(Grid, { padding: false, className: "pl-4 lg:pl-6" },
                React.createElement(Cell, { span: 12, margin: false },
                    React.createElement("div", { className: "flex justify-between items-center" },
                        logoLink ? (React.createElement(Link, { to: logoLink },
                            React.createElement("img", { className: "h-10 md:h-16 w-auto", src: logoSrc || uhmLogo, alt: title ? title : '', height: "64", width: "178" }))) : (React.createElement("img", { className: "h-10 md:h-16 w-auto", src: logoSrc || uhmLogo, alt: title ? title : '', height: "64", width: "178" })),
                        React.createElement("div", { className: "flex items-center" },
                            SearchComponent && (React.createElement("div", { className: "hidden ml-auto searchwrapper md:block" }, SearchComponent)),
                            SearchComponentMobile && (React.createElement("div", { className: "ml-auto md:hidden" }, SearchComponentMobile)),
                            CriteriaCartComponent && (React.createElement("div", { className: "mx-4" }, CriteriaCartComponent)),
                            MenuComponent && React.createElement("div", { className: "ml-4" }, MenuComponent))))))));
};
export default PageHeader;
